
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ProposalUsageAdmin from "./ProposalUsageAdmin";
import ProfileOverviewUsageAdmin from "./ProfileOverviewUsageAdmin";
import ProfileReviewUsageAdmin from "./ProfileReviewUsageAdmin";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { FileSpreadsheet, User, CheckCircle } from "lucide-react";

const AIToolsUsageAdmin = () => {
  const [activeTab, setActiveTab] = useState("proposals");

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>AI Tools Usage Dashboard</CardTitle>
          <CardDescription>
            View usage statistics for all AI-powered tools across the platform
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
            <div className="flex justify-center">
              <TabsList className="grid grid-cols-3 gap-1 w-full md:w-auto">
                <TabsTrigger value="proposals" className="flex items-center gap-2 px-4 py-2.5">
                  <FileSpreadsheet className="h-4 w-4" />
                  <span>Proposals</span>
                </TabsTrigger>
                <TabsTrigger value="profiles" className="flex items-center gap-2 px-4 py-2.5">
                  <User className="h-4 w-4" />
                  <span>Profiles</span>
                </TabsTrigger>
                <TabsTrigger value="reviews" className="flex items-center gap-2 px-4 py-2.5">
                  <CheckCircle className="h-4 w-4" />
                  <span>Reviews</span>
                </TabsTrigger>
              </TabsList>
            </div>

            <TabsContent value="proposals" className="mt-6 bg-muted/5 rounded-xl p-5 border border-muted/20 shadow-sm">
              <ProposalUsageAdmin />
            </TabsContent>

            <TabsContent value="profiles" className="mt-6 bg-muted/5 rounded-xl p-5 border border-muted/20 shadow-sm">
              <ProfileOverviewUsageAdmin />
            </TabsContent>

            <TabsContent value="reviews" className="mt-6 bg-muted/5 rounded-xl p-5 border border-muted/20 shadow-sm">
              <ProfileReviewUsageAdmin />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};

export default AIToolsUsageAdmin;
